export const FEEDBACK_ERROR_CODES = Object.freeze({
  JOB_TASK_STATUS_UNREACHABLE_ERROR: 'job_task_status_unreachable_error',
  VIEW_REPORT_NOT_IMPLEMENTED_ERROR: 'view_report_not_implemented_error',
});
